import * as Colors from "../../../globalStyles/colors";

export const mainBody = {
    // height: "16vh"
};

export const emptySpace = {
    height: "10%"
};

export const title = {
    // height: "90%",
    // width: "25%",
    backgroundColor: Colors.primary,
    textAlign: "center",
    borderRadius: "0px 50px 50px 0",
    color: "white",
    padding: "5px",
    fontWeight: "bold"
};

export const topTitle = {
    fontSize: "24px"
};

export const SubTitle = {
    // fontSize: "16px"
};

export const row = {
    marginRight: "0" //default is -15px,
};
export const clickableTitle = {
    color: "white",
    textAlign: "center"
};
